<template>
  <section id="content">
    <div v-for="(contentcard, index) in prismic_data.videos" v-bind:key="index">
      <div class="row" :class="{ 'right': index % 2 == 1 }">
        <div class="content">
          <h4
            :style="[{color: contentcard.video_content_title_color}]"
          >{{contentcard.video_content_title}}</h4>
          <p
            v-for="(contentcardText, index) in contentcard.video_content_text"
            v-bind:key="index"
          >{{contentcardText.text}}</p>
          <button
            @click="playVideo(index)"
            v-scroll-to="'#videos'"
          >{{contentcard.video_button_text}}</button>
        </div>
        <div class="image">
          <prismic-image :field="contentcard.video_content_image" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContentSection",
  props: {
    prismic_data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    playVideo(index) {
      document.getElementsByClassName("video-select-" + index)[0].click();
    },
  },
};
</script>

<style lang="scss" scoped>
#content {
  margin-top: 144px;
  @media (max-width: $breakpoint-sm) {
    margin-top: 90px;
  }
}

.row {
  display: flex;
  margin-bottom: 70px;
  margin-left: 152px;
  @media (max-width: $breakpoint-lg) {
    margin-left: 100px;
  }
  @media (max-width: $breakpoint-md) {
    margin-left: 70px;
  }
  @media (max-width: $breakpoint-sm) {
    display: flex;
    flex-direction: column;
    margin: 0;
    margin-bottom: 100px;
  }

  .image {
    margin-left: auto;
  }

  &.right {
    flex-direction: row-reverse;
    margin-right: 152px;
    margin-left: initial;
    @media (max-width: $breakpoint-lg) {
      margin-right: 100px;
    }
    @media (max-width: $breakpoint-md) {
      margin-right: 70px;
    }
    @media (max-width: $breakpoint-sm) {
      margin-right: 0;
      flex-direction: column;
    }
    .content {
      margin-left: 144px;
      margin-right: initial;
      @media (max-width: $breakpoint-md) {
        margin-left: 70px;
      }
      @media (max-width: $breakpoint-sm) {
        margin: 0;
        margin-bottom: 40px;
      }
    }

    .image {
      margin-left: initial;
      margin-right: auto;
    }
  }
}

.content {
  align-self: center;
  width: 50%;
  @media (max-width: 1440px) {
    max-width: 552px;
  }
  @media (max-width: $breakpoint-sm) {
    width: 100%;
    max-width: 100%;
    padding: 0 24px;
    margin-bottom: 40px;
  }
  p {
    line-height: 28px;
    padding-right: 83px;
    margin-bottom: 28px;
    @media (max-width: $breakpoint-sm) {
      padding-right: 0;
    }
  }
}

.content button {
  border: 1px solid $color-purple;
  color: $color-purple;
  padding: 8px 20px;
  text-transform: uppercase;
  outline: none;
  @include round-border(3px);
  @include transition(0.25s);
}

.content button:hover {
  background: $color-purple;
  color: $color-white;
}

.image {
  width: 50%;
  display: flex;
  align-items: center;
  @media (max-width: $breakpoint-sm) {
    width: 100%;
  }
  img {
    width: 100%;
  }
}

h4 {
  line-height: 62px;
  margin-bottom: 48px;
  color: #381729;
  @media (max-width: $breakpoint-md) {
    line-height: 52px;
  }
  @media (max-width: $breakpoint-sm) {
    line-height: 42px;
    margin-bottom: 40px;
  }
}
</style>